import repository from '@/utils/repository';

const common_resource = '/move';
const group_resource = '/move/MNG_Master010';

export default {
    searchAreaInfo: (data) => {
        return repository.post(`${common_resource}/postCommonMst005Info`, {
            ...data
        });
    },
    searchGroupInfo: (data) => {
        return repository.post(`${group_resource}/searchItem`, {
            ...data
        });
    }
};
